import { useCallback } from "react";
import {
  hasShownBookingSurvey,
  hasViewedResults,
  markBookingSurveyShown,
  openBookingSurveyDeeplink,
  type CsatVertical,
} from "../utils/csatSurvey";

type UseBookingSurveyAbandonmentOptions = {
  vertical: CsatVertical;
  enabled?: boolean;
};

export function useBookingSurveyAbandonment({
  vertical,
  enabled = false,
}: UseBookingSurveyAbandonmentOptions) {
  const tryInterruptAbandonment = useCallback(() => {
    if (
      !enabled ||
      !hasViewedResults(vertical) ||
      hasShownBookingSurvey(vertical)
    ) {
      return false;
    }

    markBookingSurveyShown(vertical);
    openBookingSurveyDeeplink({
      vertical,
      screen: "search_screen",
    });
    return true;
  }, [enabled, vertical]);

  return { tryInterruptAbandonment };
}
